var typography = {"display":"_display_5wz57_75"};

export { typography as default };
